$(() => {
	var url: string = $('#servico-full-url').val();
	$('#servico-full-url').remove();
	$('#servico-avaliacao-telefone').mask('(99) 99999-9999');

	$('#servico-print').click(function() {
		var action: string = null;
		var data = {
			action: null,
			categoria: null,
			ref: null,
			tipo: null
		};
		var categoria: number = null;
		var ref: number = null;
		var tipo: number = null;
		var self = $(this);

		action = 'servico_print';
		categoria = parseInt($(this).attr('categoria'));
		ref = parseInt($(this).attr('ref'));
		tipo = parseInt($(this).attr('tipo'));

		data.action = action;
		data.categoria = categoria;
		data.ref = ref;
		data.tipo = tipo;

		self.button('loading');
		$.post('/load', data, function(r) {
			self.button('reset');
			var newWin = document.getElementById('servico-print-iframe').contentWindow;
			newWin.document.write(r);
			newWin.document.close(); //important!
			newWin.focus(); //IE fix
			document.getElementById('servico-print-iframe').style.display = 'block';
			newWin.print();
			document.getElementById('servico-print-iframe').style.display = 'none';
		});
	});

	$('.servico-star').hover(
		function() {
			var ref: number = parseInt($(this).attr('ref'));
			$('.servico-star').each(function() {
				var n: number = parseInt($(this).attr('ref'));
				if (n <= ref) {
					$(this).addClass('active');
				} else {
					$(this).removeClass('active');
				}
			});
		},
		function() {
			$('.servico-star').removeClass('active');
		}
	);

	$('.servico-star').click(function() {
		var html: string = '';
		var nota: number = parseInt($(this).attr('ref'));

		html += nota + ' ';

		for (var i = 1; i <= 5; i++) {
			if (nota >= i) {
				html += "<i class='mdi mdi-star'></i> ";
			}
		}

		$('#m-servico-avaliacao').modal('show');
		$('#servico-avaliacao-nota').html(html);
		$('#servico-cfm').attr('nota', nota);
	});

	var errorTimeout = null;
	var showError = function(error) {
		$('#servico-avaliacao-error').html(error).show();
		window.clearTimeout(errorTimeout);
		errorTimeout = window.setTimeout(function() {
			$('#servico-avaliacao-error').hide();
		}, 5000);
	};

	$('#servico-cfm').click(function() {
		var cname: string = null;
		var data = {
			action: null,
			motivo: null,
			nome: null,
			nota: null,
			ref: null,
			telefone: null
		};
		var motivo: string = null;
		var nome: string = null;
		var nota: number = null;
		var ref: number = null;
		var self = $(this);
		var telefone: string = null;

		motivo = $('#servico-avaliacao-motivo').val().toString();
		nome = $('#servico-avaliacao-nome').val().toString();
		nota = parseInt($(this).attr('nota'));
		ref = parseInt($(this).attr('ref'));
		telefone = $('#servico-avaliacao-telefone').val().toString();

		cname = 's' + ref;

		data.action = 'servico_avaliar';
		data.motivo = motivo;
		data.nome = nome;
		data.nota = nota;
		data.ref = ref;
		data.telefone = telefone;

		self.button('loading');
		$.post('/load', data, function(r) {
			self.button('reset');
			r = JSON.parse(r);
			if (r.response) {
				Cookies.set(cname, nota, { expires: 365 });
				window.location = window.location.href + '/voted';
			} else {
				showError(r.error);
			}
		});
	});

	$('.n-c-social-btn.fb').click(() => {
		window.open(
			'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});

	$('.n-c-social-btn.tw').click(() => {
		window.open(
			'http://twitter.com/share?url=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});
});
